import type { FunctionComponent, ReactNode } from 'react';
import { useState } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { AnimatedTabs, TabsContent } from '~/ui/core/tabs/Tabs';

import { recommendedAgentsTranslationKeys as keys } from './recommended-agents-translations';

const PROFILE_TAB = 'profile';
const AUTOMATIONS_TAB = 'automations';
const PANEL_CLASS = 'p-0 text-inherit';

const Tabbed: FunctionComponent<{
    readonly automations: ReactNode;
    readonly children: ReactNode;
}> = ({ automations, children }) => {
    const translate = useTranslate();
    const [tab, setTab] = useState(PROFILE_TAB);

    return (
        <AnimatedTabs
            tabs={[
                { label: translate(keys.tabProfile), value: PROFILE_TAB },
                { label: translate(keys.tabAutomations), value: AUTOMATIONS_TAB },
            ]}
            value={tab}
            onValueChange={setTab}
        >
            <TabsContent className={PANEL_CLASS} value={PROFILE_TAB}>
                {children}
            </TabsContent>
            <TabsContent className={`${PANEL_CLASS} mt-xl`} value={AUTOMATIONS_TAB}>
                {automations}
            </TabsContent>
        </AnimatedTabs>
    );
};

/**
 * Profile and Automations tabs, or the profile alone while [isEnabled] is off. The automations panel mounts only while
 * it is the open tab.
 */
export const ProfileAutomationsTabs: FunctionComponent<{
    readonly automations: ReactNode;
    readonly children: ReactNode;
    readonly isEnabled: boolean;
}> = ({ automations, children, isEnabled }) =>
    isEnabled ? <Tabbed automations={automations}>{children}</Tabbed> : children;
